export type ApiErrorResponse = {
  code?: number;
  reason?: string;
  message?: string;
  domain?: string;
  developer_message?: string;
  details?: Record<string, string>;
};

export class ApiError extends Error {
  public readonly code?: number;
  public readonly reason?: string;
  public readonly developerMessage?: string;
  public readonly domain?: string;
  public readonly details?: Record<string, string>;

  constructor(response: ApiErrorResponse) {
    super(response.message || 'Something went wrong');
    this.name = 'ApiError';
    this.code = response.code;
    this.reason = response.reason || 'SOMETHING_WENT_WRONG';
    this.developerMessage = response.developer_message;
    this.domain = response.domain;
    this.details = response.details;
  }

  static isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError;
  }
}

export const toApiError = (error: unknown): ApiError => {
  if (ApiError.isApiError(error)) {
    return error;
  }

  if (error instanceof Error) {
    return new ApiError({ message: error.message });
  }

  return new ApiError({ message: 'Unknown error' });
};
